const isValidChar = str => str.length === 1 && str.match(/\S/);

const getCharIndex = ({ char, count, focusableItems, start }) => {
  for (let i = start; i < count; i++) {
    if (
      focusableItems &&
      char ===
        focusableItems[i].dataset.listItemLabel
          .trim()
          .toLowerCase()
          .substring(0, 1)
    ) {
      return i;
    }
  }
  return -1;
};

export { getCharIndex, isValidChar };
